/*New VF User*/

import { Field, Form, Formik ,useField , ErrorMessage} from "formik";
import React, { useEffect, useId, useState } from "react";
import * as Yup from "yup";
import Asterisk from "../../../../components/asterisk/Asterisk";
import { BackButton, Submit } from "../../../../components/button/buttons";
import { TextInput } from "../../../../components/input/inputs";
import IMAGES from "../../../../assets/images/images";  
import { FormFieldLabel as Label ,FormErrorLabel as ErrorLabel, FormImgErrorLabel, FormImgAvailableLabel} from "../../../../components/label/Labels";
import { Sidebar } from "../../../../components/sidebar/Sidebar";
import styles from "./NewVFUser.module.css";
// import { Alert } from "../../../../components/alert/alerts";
import { FUNCTIONAL_ROLES_CONSTANTS, USER_TYPE } from "../../../../utils/constants/userConstants";
import { capitalizeWords } from "../../../../utils/utils";
import DropDown from "../../../../components/dropDown/DropDown";
import { UserManagementTab } from "../../../../utils/constants/userManagementConstant";
import { Loader } from "../../../../components/loader/Loader";
const FieldWrapper = ({ children }) => {
  return <div className={styles.fieldContainer}>{children}</div>;
};

const TextField = ({ label, placeholder,isCheckingEmail, checkAvailability,customError, ...props }) => {
  const [field, meta, helpers] = useField(props);
  const hasError = meta.touched && meta.error ? true : false;
  const inputStyle = hasError ? styles.inputError : checkAvailability === true ? styles.textavailable : styles.textfield;
  return (
    <FieldWrapper>
      <div>
        <Label text={label} />
        <Asterisk />
      </div>
      <TextInput  {...field}  {...props} placeholder={placeholder}   style={inputStyle}  onChange={props.onChange}/>
      {isCheckingEmail ? (<div className={styles.loaderclass}><span><Loader loaderStyle={styles.loader}/></span><span>Verifying email</span></div>)
       :(<div>
      {hasError ? (
        customError ? (
        <FormImgErrorLabel text={meta.error} />
       ) : (<ErrorLabel text={meta.error} />)
       ) : checkAvailability === true ? (
        <FormImgAvailableLabel text="Available"/>
       ) : checkAvailability === false ? (
        <FormImgErrorLabel text="This Email Address exists. Try another"/>
       ):null }</div>)}
    </FieldWrapper>
  );
};

const PhoneNumberTextField = ({ label, placeholder, ...props }) => {
  return (
    <FieldWrapper>
      <div>
        <Label text={label} />
      </div>
      <TextInput {...props} placeholder={placeholder} />
    </FieldWrapper>
  );
};

const CheckBox = ({ name, value, label }) => {
  const id = useId();
  return (
    <div className={styles.radioField}>
      <Field
        id={id}
        className={styles.radioInput}
        type="checkbox"
        name={name}
        value={value}
      />
      <label htmlFor={id} className={styles.radioLabel}>
        {label}
      </label>
    </div>
  );
};
const RadioField = ({ name, value, label }) => {
  const id = useId();
  return (
    <div className={styles.radioField}>
      <Field
        id={id}
        className={styles.radioInput}
        type="radio"
        name={name}
        value={value}
      />
      <label htmlFor={id} className={styles.radioLabel}>
        {label}
      </label>
    </div>
  );
};
const ButtonWrapper = ({ children }) => {
  return <div className={styles.buttonContainer}>{children}</div>;
};

const SelectField = ({ title, options, ...props }) => {
  let _options = options?.map((item) => ({
    value: item?.value,
    label: item?.label,
  }));
  const [field, meta, helpers] = useField(props);

  const hasError = meta.touched && meta.error ? true : false;
  return (
    <FieldWrapper>
      <div>
        <Label text={title}  style={`${styles.labelcompLevel} ${props.additionalStyle}`} /><Asterisk />
        <span className={styles.circlered}>
          <span className={styles.tooltip}>
            {props.name === "ServiceImpacted" ? <Asterisk /> : <></>}
            {/* <Tooltip text={props.tooltiptxt} /> */}
          </span>
        </span>
      </div>
      <DropDown
        options={_options}
        customStyles={props.customStyles}
        onChange={({ label, value }) => {
          helpers.setValue(value);
          props.onChange(value);
        }}
        value={
          _options && field.value
            ? _options.find((option) => option.value === field.value)
            : ""
        }
        hasError={hasError}
        isDisabled={props.isDisabled}
      />
      {hasError ? <ErrorLabel text={meta.error} /> : null}
    </FieldWrapper>
  );
};

const ExpandableArea = ({ children }) => {
  const [expanded, setExpanded] = useState(false);

  if (!expanded) {
    return (
      <div className={styles.expanded}>
        <button
          className={styles.transparentBtn}
          onClick={() => setExpanded(true)}
        >
          <span className={styles.view}>View All</span>
          <img src={IMAGES.arrowdown} width={24} height={24} alt="down arrow" />
        </button>
      </div>
    );
  }

  return (
    <div className={styles.expanded}>
       {children}
      <div>
        <button
          className={styles.transparentBtn}
          onClick={() => setExpanded(false)}
        >
          <span className={styles.view}>View Less</span>
          <img src={IMAGES.arrowup} width={24} height={24} alt="up arrow" />
        </button>
      </div>

     
    </div>
  );
};
// const validationSchema = Yup.object().shape({
//   email: Yup.string().email("Invalid email").max(100,"Email must be at most 100 characters").required("Required")
//   .test({
//     name: 'Edit Restriction',
//     message: "You cannot update your own permissions.",
//     test: function(value) {
//       if (props.source=='edit' && value === props?.myRights?.email) {
//         return false;
//       }
//       return true;
//     }
//   }),
//   fullName: Yup.string()
//     .matches(/^\S(.*\S)?$/, "Space not allowed at start and end")
//     .min(2, "Too Short!")
//     .max(100,"Name must be at most 100 characters")
//     .required("Required"),
//     phoneNumber: Yup.string().matches(/^(\+\d{1,3}[- ]?)?\d{10}$/, "Invalid mobile number").nullable(true),
//     functionalRoles:Yup.string().required("Kindly choose one role.") //array().min(1,"Kindly choose at least one role.").max(1,"Please select only one role.")
// });

const NewVFUser = (props) => {
  const {functionalRoles,redirect,myRights,UserName,UserRole,userList,sortConfig}=props;
  const [showAddUser, setShowAddUser] = useState(redirect?true:false);
  const [isSubmit, setIsSubmit] = useState(false);
  let [isAlert, setIsAlert] = useState(false);
  let [isEditPermission, setIsEditPermission] = useState(false);
  const [message, setMessage] = useState({
    message: "",
    image: IMAGES.success
  });
  // const [errorMsg,setErrorMsg] = useState("")
  let existingEmails = userList?.map((existing) => existing.email);
  const [checkAvailability, setAvailability] = useState(null);
  const [isCheckingEmail, setIsCheckingEmail] = useState(false);

  const handleCustomBlur = async (e,handleBlur,errors) => {
  const value = e.target.value?.trim();
  handleBlur(e);
  if (e.target.name !== "email") return;

  const hasYupErrorNow = !!errors?.email;
  if (!value || hasYupErrorNow) {
    setAvailability(null);
    return;
  }
try {
    setIsCheckingEmail(true); 
    const result = await props.getEmailToVerify(value);
    const isValidEmail = result?.res?.data?.isEmailPresentInOnboardingReqest === false && result?.res?.data?.isEmailPresentInRights === false;
    setAvailability(isValidEmail);
} catch (err) {
    setAvailability(null);
  } finally {
    setIsCheckingEmail(false);
  }
  };

  useEffect(()=>{
    if(redirect===UserManagementTab.VF_GROUP_USER){
      props.redirectTab("")
    }
  },[])

  let initialValues = {
    email: props?.data?.email || "",
    fullName: props?.data?.displayName || "",
    phoneNumber: null,
    assignModule: "manual",
    userType: "internal",
    cpName: null, 
    functionalRoles: props?.data?.functionalRoles && props?.data?.functionalRoles.length > 0? props?.data?.functionalRoles.toString(): "",
  };
const functionalRolesData = functionalRoles?.map((role) => ({
  value: role?.id,
  label: role?.name,
}));

  const close = () => {
    setIsSubmit(false);
    setShowAddUser(false);
    setAvailability(null)
    props.redirectTab("");
    // setErrorMsg("");
  };

  const editPermission =()=>{
    setIsEditPermission(!isEditPermission);
  }

  const createUser=(obj)=>{
    props.createUser(obj).then((result) => {
      if (result.status) {
        setIsSubmit(false);
        props.openAlertPopup({
          message: "New user added successfully!",
          image: IMAGES.success
        });
       
        close();
        setIsAlert(true);
        let searchKey = "";
        let type=USER_TYPE.INTERNAL;
        let custID="";
        let next=null;
        props.getUser(type,custID,searchKey,next);
      } else {
        setIsSubmit(false);
        let error_msg = result?.error;
        close();
        props.openAlertPopup({
          message: error_msg,
          image: IMAGES.error
        });
      }
    })
      .catch((error) => {
        setIsSubmit(false);
        close();
        props.openAlertPopup({
          message: "An error occurred while processing your request. Please try again later.",
          image: IMAGES.error
        });
      });
  }

  const updateUser=(obj,values)=>{
 
    let objs =  { 
      "functionalRoles":[values?.functionalRoles],
       userType:props?.data?.userType
      }
      setIsSubmit(true);
      props.updateUserPermissions(objs, props?.data?.uid)
        .then((result) => {
          setIsSubmit(false);
          setIsEditPermission(!isEditPermission);
          if (result.status) {
            props.openAlertPopup({
              message: "User permissions updated successfully!",
              image: IMAGES.success
            });
            const selectedNames = UserName.map((item) => item.value).join(",");
            const selectedRoles = UserRole.map((item) => item.value).join(",");
            const sort = `${sortConfig.field}:${sortConfig.order}`;
            props.getUser(USER_TYPE.INTERNAL,"","","",selectedNames,selectedRoles,sort);
            close();
          } else {
            let error_msg = result?.error;
            props.openAlertPopup({
              message: error_msg,
              image: IMAGES.error
            });
            close();
          }
        })
        .catch((error) => {
          setIsSubmit(false);
          setIsEditPermission(!isEditPermission);
          props.openAlertPopup({
            message: "An error occurred while processing your request. Please try again later.",
            image: IMAGES.error
          });
          close();
        });
  }

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .matches(/^\S(.*\S)?$/, "Space not allowed at start and end")
      .email("Invalid email")
      .max(100, "Email must be at most 100 characters")
      .required("Required"),
    // .test("unique", "This Email Address exists. Try another", function (value) { 
    //   if (props?.source === "edit") return true; 
    //   return !existingEmails?.includes(value)}),
    // .test({
    //   name: 'Edit Restriction',
    //   message: "You cannot update your own permissions.",
    //   test: function(value) {
    //     if (props.source=='edit' && value === props?.myRights?.email) {
    //       setErrorMsg("You cannot update your own permissions.");
    //       return false;
    //     }
    //     return true;
    //   }
    // }),
    fullName: Yup.string()
      .matches(/^\S(.*\S)?$/, "Space not allowed at start and end")
      .min(2, "Too Short!")
      .max(100,"Name must be at most 100 characters")
      .required("Required"),
      phoneNumber: Yup.string().matches(/^(\+\d{1,3}[- ]?)?\d{10}$/, "Invalid mobile number").nullable(true),
      functionalRoles:Yup.string().required("Kindly choose one role.") //array().min(1,"Kindly choose at least one role.").max(1,"Please select only one role.")
  });


  return (
    <div>
      {props.source=='edit'  ?(
          <div  onClick={props?.data?.status === 'active'? () => setShowAddUser(true):null}> {props.data.email===myRights.email?<img className={styles.editrole} src={IMAGES.eyeicon} />:<img className={props?.data?.status === 'active'?`${styles.editrole}`:`${styles.notallow}`} src={IMAGES.editrole} />}</div>
      ) : (
        <button
        onClick={() => {setShowAddUser(true)
                        setAvailability(null)}}
        className={styles.addButton}
      >
        Add New Vodafone User

      </button>
      )}
      {showAddUser && (
        <Sidebar
          isOpen={showAddUser}
          headerTxt={`${props.source=='edit'?props.data.email===myRights.email?"View Access":"Edit Access":"Add New Vodafone User"}`}
          onClose={close}
          sideNavStyle={styles.sideNavStyle}
        >
          <Formik
          
            initialValues={initialValues}
            validationSchema={validationSchema}
            validateOnChange
            onSubmit={async (values) => {
              let obj = JSON.parse(JSON.stringify(values));
              obj.fullName=values?.fullName?.trim();
              obj.email=values?.email?.trim()?.toLowerCase();
              delete obj.assignModule; 
              obj.functionalRoles=[values.functionalRoles];
              setIsSubmit(true);
              if(props.source=='new'){
                createUser(obj);
              }else{
                updateUser(obj,values);
              }
            }
          }

          >
            {({
              isValid,
              dirty,
              setFieldValue,
              values,
              handleChange,
              handleBlur,
              setFieldError,
              setFieldTouched,
              errors
            }) => (
              <Form className={styles.form}>
                <fieldset  className={styles.formscroll}>
                  <TextField
                    label="Email Address"
                    name="email"
                    type="text"
                    placeholder="Input text"
                     onChange={(e) => {
                      handleChange(e);                 
                      setAvailability(null);
                    }}
                    onBlur={(e)=>handleCustomBlur(e,handleBlur,errors)}       
                    disabled={props.source=='edit'} 
                    customError={true}
                    checkAvailability={checkAvailability} 
                    isCheckingEmail={isCheckingEmail}         
                  />
                  <TextField
                    label="Full Name"
                    name="fullName"
                    type="text"
                    placeholder="Input text"
                  //  onChange={handleChange}
                    onBlur={handleBlur}
                    onChange={(e)=>{
                      setFieldValue("fullName",capitalizeWords(e.target.value));
                      }}
                    customError={false}
                    disabled={props.source=='edit'}
                    // checkAvailability={false}  
                  />
                   <SelectField
                                title={"User Role"}
                                name="functionalRoles"   
                                options={functionalRolesData}
                                customStyles={styles.obj}
                                placeholder="Enter name"
                                isDisabled={props.data.email===myRights.email}
                               onChange={(value)=>{
                              //  setFieldValue("primaryContactName", value)
                               }}
                               />
                               {props.data.email===myRights.email&&(<span className={styles.permission}>You cannot update your own permissions.</span>)}
                {/* <div className={styles.discription}>
                   <div className={styles.userrole}>User Roles</div>
                   <div class={styles.gridcontainer}>
                   {props.functionalRoles?.slice(0, 4)?.map((role) => (                                 
                       <div class={styles.griditem}>                       
                            <div className={styles.rolename}>{role.name}</div>
                            <div className={styles.roleinfo}>{role.description}</div>                                               
                       </div>                      
                 ))}
                   </div> 
                <ExpandableArea>
                <div style={{ width: "100%" }}>
           
                   <div class={styles.gridcontainer}>
                   {props.functionalRoles?.slice(4)?.map((role) => (                     
                           <div class={styles.griditem}>                       
                            <div className={styles.rolename}>{role.name}</div>
                            <div className={styles.roleinfo}>{role.description}</div>                                                
                       </div>                     
                 ))}
                   </div> 
                   </div>
                </ExpandableArea>
                </div> */}
                  {/*<PhoneNumberTextField
                    label="Mobile number"
                    name="phoneNumber"
                    type="text"
                    placeholder="XXXXX XXXXX"
                    onChange={handleChange}
                    onBlur={handleBlur}
            />*/}
            
                {/* <h2 className={styles.assign}>Assign Role</h2> */}
                 {/* <div>
                    <div className={styles.radioGroup}>
                      <div className={styles.radioField}>
                        <Field
                          id="manual"
                          type="radio"
                          name="assignModule"
                          value="manual"
                          className={styles.radioInput}
                        />
                        <label htmlFor="manual" className={styles.radioLabel}>
                          Select Manually
                        </label>
                      </div>

                      <div className={styles.radioField}>
                        <Field
                          id="admin"
                          className={styles.radioInput}
                          type="radio"
                          name="assignModule"
                          value="admin"
                          onClick={(val) => {
                            setFieldValue(
                              "functionalRoles",
                              functionalRoles.map((role) => role.id)
                            );
                          }}
                        />
                        <label htmlFor="admin" className={styles.radioLabel}>
                          Make an admin
                          <br /> (gives access to all modules)
                        </label>
                      </div>
                    </div>
                  </div>*/}

                  {/* <fieldset
                    disabled={values.assignModule === "admin"}
                    className={styles.checkboxaligngrid}
                  >
                    {functionalRoles?.map((role) => (
                      <RadioField name="functionalRoles" value={role.id} label={role.name}/>
                    ))}
                  </fieldset>
                  <ErrorMessage name ="functionalRoles">
                    {(msg)=><ErrorLabel text={msg} />}
                  </ErrorMessage> */}
                </fieldset>
                 

                <div>
                  <hr className={styles.separator} />
                  <ButtonWrapper>
                    <BackButton
                      className={styles.backButton}
                      style={styles.submit}
                      title={"Back"}
                      closePopup={close}
                      // onClose={close}
                    />
                    <Submit
                      title={props.source=="edit"?"Save Change": "Submit"}
                      isSubmitting={isSubmit}
                     disabled={!isValid || !dirty || ((checkAvailability !== true) && props.source !=='edit')}
                    />
                  </ButtonWrapper>
                </div>
              </Form>
            )}
          </Formik>
        </Sidebar>
      )}
      {/* {isAlert && (
                  <div
                    style={{
                      zIndex: 20,
                      position: "fixed",
                      bottom: 0,
                      left: 0,
                      width: "100%",
                    }}
                  >
                    <Alert
                      image={message.image}
                      message={message.message}
                      onClose={setIsAlert}
                    />
                  </div>
                )} */}
    </div>
  );
};

export default NewVFUser;
